// extracted by mini-css-extract-plugin
export default {"post_detail":"PostDetail_post_detail__0rnZt","tags":"PostDetail_tags__gw++G","createdBy":"PostDetail_createdBy__SO7QB"};